import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { RowButton } from '../styles';

export const StepSeatsAside = styled(ShadowBoxDark).attrs({
  className: 'b-step-seats__aside'
})`
  width: 329px;
  padding: ${({ theme }) => theme.indent.m};

  ${RowButton} {
    text-align: center;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    width: 100%;
    padding: 0;
    background: none;
    box-shadow: none;
  }
`;

export const SeatPlanNote = styled.p.attrs({
  className: 'b-step-seats__note'
})`
  margin-top: ${({theme}) => theme.indent.s};
  font-size: 1.4rem;
  color: ${({theme}) => theme.color.textSecondary};
  
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    text-align: center;
  }
`;
